/**
 * Calculates seconds remaining between now and target timestamp
 * Returns 0 if timestamp is in the past
 */
export function calculateTimeLeft(timestamp: string): number {
  return Math.max(
    0,
    Math.floor((new Date(timestamp).getTime() - Date.now()) / 1000),
  )
}

/**
 * Formats seconds into HH:MM:SS or MM:SS format
 * Hours are only displayed when present
 */
export function formatRemainingTime(totalSeconds: number): string {
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  if (hours > 0) {
    return `${hours}:${padNumber(minutes)}:${padNumber(seconds)}`
  }
  return `${minutes}:${padNumber(seconds)}`
}

/**
 * Ensures numbers are displayed with two digits (e.g., 5 becomes "05")
 */
function padNumber(num: number): string {
  return num.toString().padStart(2, '0')
}
